// ======================================================================
// FILE: src/modules/wms/work/pages/WorkListPage.js
// MODULE: Work Management System (WMS)
// FEATURE: Work Management
// PURPOSE:
//   Work Listing Screen
// ======================================================================

import React, {
  useEffect,
  useState,
} from "react";

import {
  Link,
  useNavigate,
} from "react-router-dom";

import wmsWorkService
from "../../services/wmsWorkService";

export default function WorkListPage() {

  const navigate =
    useNavigate();

  const [loading, setLoading] =
    useState(false);

  const [rows, setRows] =
    useState([]);

  const [pagination, setPagination] =
    useState({});

  const [summary, setSummary] =
    useState({
      totalWorks: 0,
      openWorks: 0,
      inProgressWorks: 0,
      completedWorks: 0,
    });

  const [filters, setFilters] =
    useState({
      q: "",
      status: "",
      priority: "",
      work_mode: "",
      page: 1,
      per_page: 20,
    });

  // ==========================================================
  // LOAD
  // ==========================================================

  async function loadData() {

    try {

      setLoading(true);

      const result =
        await wmsWorkService
          .listWorks(filters);

      const items =
        result.items || [];

      setRows(items);

      setPagination(
        result.pagination || {}
      );

      let openCount = 0;
      let progressCount = 0;
      let completedCount = 0;

      items.forEach((row) => {

        if (
          row.status === "OPEN"
        ) {
          openCount++;
        }

        if (
          row.status ===
          "IN_PROGRESS"
        ) {
          progressCount++;
        }

        if (
          row.status ===
          "COMPLETED"
        ) {
          completedCount++;
        }

      });

      setSummary({

        totalWorks:
          result.pagination?.total
          || items.length,

        openWorks:
          openCount,

        inProgressWorks:
          progressCount,

        completedWorks:
          completedCount,
      });

    } catch (err) {

      console.error(err);

      alert(
        err?.response?.data?.message
        || "Failed to load works"
      );

    } finally {

      setLoading(false);
    }
  }

  useEffect(() => {

    loadData();

  }, [filters.page]);

  // ==========================================================
  // SEARCH
  // ==========================================================

  function handleSearch() {

  setFilters((prev) => ({
    ...prev,
    page: 1,
  }));

  loadData();
}

  // ==========================================================
  // DELETE
  // ==========================================================

  async function handleDelete(row) {

    const ok = window.confirm(
      `Delete Work ${row.title}?`
    );

    if (!ok) {
      return;
    }

    try {

      await wmsWorkService
        .deleteWork(row.id);

      await loadData();

    } catch (err) {

      alert(
        err?.response?.data?.message
        || "Delete failed"
      );
    }
  }

  // ==========================================================
  // PAGINATION
  // ==========================================================

  function changePage(page) {

    setFilters((prev) => ({
      ...prev,
      page,
    }));
  }
  return (

    <div className="container-fluid">

      {/* ==================================================== */}
      {/* PAGE HEADER */}
      {/* ==================================================== */}

      <div
        className="card border-0 mb-4"
        style={{
          background:
            "linear-gradient(90deg,#0d6efd,#4f8cff)",
          borderRadius: "12px",
          color: "#fff",
        }}
      >

        <div
          className="
            card-body
            d-flex
            justify-content-between
            align-items-center
          "
        >

          <div>

            <h2 className="mb-1">
              Work Management
            </h2>

            <div>
              Manage template and adhoc works
            </div>

          </div>

          <div>

            <button
              className="btn btn-light me-2"
              onClick={loadData}
            >
              <i className="fas fa-sync-alt me-2" />
              Refresh
            </button>

            <Link
              to="/wms/works/create"
              className="btn btn-outline-light"
            >
              <i className="fas fa-plus me-2" />
              Create Work
            </Link>

          </div>

        </div>

      </div>

      {/* ==================================================== */}
      {/* KPI */}
      {/* ==================================================== */}

      <div className="row mb-4">

        <div className="col-md-3">

          <div
            className="card shadow-sm h-100"
            style={{
              borderTop:
                "4px solid #0d6efd",
            }}
          >

            <div className="card-body d-flex justify-content-between">

              <div>

                <div className="text-muted small">
                  Total Works
                </div>

                <h2 className="mb-0 fw-bold" >
                    
                  {summary.totalWorks}
                </h2>

              </div>

              <i
                className="fas fa-briefcase"
                style={{
                  fontSize: 28,
                  color: "#0d6efd",
                }}
              />

            </div>

          </div>

        </div>

        <div className="col-md-3">

          <div
            className="card shadow-sm h-100"
            style={{
              borderTop:
                "4px solid #28a745",
            }}
          >

            <div className="card-body d-flex justify-content-between">

              <div>

                <div className="text-muted small">
                  Open Works
                </div>

                <h2 className="mb-0 fw-bold" >
                  {summary.openWorks}
                </h2>

              </div>

              <i
                className="fas fa-folder-open"
                style={{
                  fontSize: 28,
                  color: "#28a745",
                }}
              />

            </div>

          </div>

        </div>

        <div className="col-md-3">

          <div
            className="card shadow-sm h-100"
            style={{
              borderTop:
                "4px solid #fd7e14",
            }}
          >

            <div className="card-body d-flex justify-content-between">

              <div>

                <div className="text-muted small">
                  In Progress
                </div>

                <h2 className="mb-0 fw-bold" >
                  {summary.inProgressWorks}
                </h2>

              </div>

              <i
                className="fas fa-spinner"
                style={{
                  fontSize: 28,
                  color: "#fd7e14",
                }}
              />

            </div>

          </div>

        </div>

        <div className="col-md-3">

          <div
            className="card shadow-sm h-100"
            style={{
              borderTop:
                "4px solid #6f42c1",
            }}
          >

            <div className="card-body d-flex justify-content-between">

              <div>

                <div className="text-muted small">
                  Completed
                </div>

                <h2 className="mb-0 fw-bold" >
                  {summary.completedWorks}
                </h2>

              </div>

              <i
                className="fas fa-check-circle"
                style={{
                  fontSize: 28,
                  color: "#6f42c1",
                }}
              />

            </div>

          </div>

        </div>

      </div>

      {/* ==================================================== */}
      {/* SEARCH */}
      {/* ==================================================== */}

      <div className="card shadow-sm mb-4">

        <div className="card-body">

          <div className="row">

            <div className="col-md-3">

              <label>
                Search
              </label>

              <input
                className="form-control"
                placeholder="Work No / Title"
                value={filters.q}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    q: e.target.value,
                  })
                }
              />

            </div>

            <div className="col-md-2">

              <label>
                Status
              </label>

              <select
                className="form-control"
                value={filters.status}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    status: e.target.value,
                  })
                }
              >

                <option value="">
                  All
                </option>

                <option value="OPEN">
                  Open
                </option>

                <option value="IN_PROGRESS">
                  In Progress
                </option>

                <option value="COMPLETED">
                  Completed
                </option>

              </select>

            </div>

            <div className="col-md-2">

              <label>
                Priority
              </label>

              <select
                className="form-control"
                value={filters.priority}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    priority: e.target.value,
                  })
                }
              >

                <option value="">
                  All
                </option>

                <option value="LOW">
                  Low
                </option>

                <option value="MEDIUM">
                  Medium
                </option>

                <option value="HIGH">
                  High
                </option>

              </select>

            </div>

            <div className="col-md-2">

              <label>
                Work Mode
              </label>

              <select
                className="form-control"
                value={filters.work_mode}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    work_mode: e.target.value,
                  })
                }
              >

                <option value="">
                  All
                </option>

                <option value="ADHOC">
                  Adhoc
                </option>

                <option value="TEMPLATE">
                  Template
                </option>

              </select>

            </div>

            <div className="col-md-3">

              <label>
                Actions
              </label>

              <div className="d-flex gap-2"></div>

              <button
                className="
                    btn
                    btn-primary
                    w-100
                "
                onClick={handleSearch}
                >
                <i className="fas fa-search me-2" />
                Search
                </button>
                <button
                className="
                    btn
                    btn-outline-secondary
                    w-100
                    mt-2
                "
                onClick={() => {

                    setFilters({
                    q: "",
                    status: "",
                    priority: "",
                    work_mode: "",
                    page: 1,
                    per_page: 20,
                    });

                    loadData();

                }}
                >
                Reset
                </button>

            </div>

          </div>

        </div>

      </div>


  
  {/* ==================================================== */}
  {/* WORK GRID */}
  {/* ==================================================== */}

  <div className="card shadow-sm">
    <div className="card-header">

    <h5 className="mb-0">
        Works
    </h5>

    </div>

    <div className="card-body p-0">

      <div className="table-responsive">

        <table className="table table-hover mb-0">

          <thead
        className="table-light"
        style={{
            position: "sticky",
            top: 0,
            zIndex: 1,
        }}
        >

            <tr>

              <th className="text-nowrap">  Work No </th>

              <th className="text-nowrap">Title</th>

              <th className="text-nowrap">Mode</th>

              <th className="text-nowrap">Priority</th>

              <th className="text-nowrap">Status</th>

              <th className="text-nowrap">Due Date</th>

              <th className="text-nowrap">Completion %</th>

              <th width="160" className="text-nowrap">
                Actions
              </th>

            </tr>

          </thead>

          <tbody>

            {loading && (

              <tr>

                <td
                  colSpan="8"
                  className="text-center p-4"
                >
                  <div
                    className="
                        d-flex
                        justify-content-center
                        p-4
                    "
                    >

                    <div
                        className="
                        spinner-border
                        text-primary
                        "
                    />

                    </div>
                </td>

              </tr>
            )}

            {!loading &&
              rows.length === 0 && (

              <tr>

                <td
                  colSpan="8"
                  className="text-center p-4"
                >
                  No works found
                </td>

              </tr>
            )}

            {!loading &&
              rows.map((row) => (

              <tr key={row.id}>

                <td>
                  {row.work_no}
                </td>

                <td>
                  {row.title}
                </td>

                <td>
                  {row.work_mode}
                </td>

                <td>

                <span
                    className={
                    row.priority === "HIGH"
                        ? "badge bg-danger"
                        : row.priority === "MEDIUM"
                        ? "badge bg-warning text-dark"
                        : "badge bg-secondary"
                    }
                >
                    {row.priority}
                </span>

                </td>

                <td>

                <span
                    className={
                    row.status === "COMPLETED"
                        ? "badge bg-success"
                        : row.status === "IN_PROGRESS"
                        ? "badge bg-warning"
                        : "badge bg-primary"
                    }
                >
                    {row.status}
                </span>

                </td>

                <td>
                  {row.planned_due_date
                    ? new Date(
                        row.planned_due_date
                      ).toLocaleDateString()
                    : "-"
                  }
                </td>

                <td style={{ minWidth: "140px" }}>

                <div className="progress">

                    <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                        width: `${
                        row.completion_percentage || 0
                        }%`
                    }}
                    >

                    {row.completion_percentage || 0}%

                    </div>

                </div>

                </td>

                <td className="text-nowrap">

  <div className="d-flex gap-1">

    <button
      className="btn btn-sm btn-outline-info"
      onClick={() =>
        navigate(`/wms/works/${row.id}/details`)
      }
    >
      <i className="fas fa-eye me-1" />
      View
    </button>

    <button
      className="btn btn-sm btn-outline-primary"
      onClick={() =>
        navigate(`/wms/works/${row.id}/edit`)
      }
    >
      <i className="fas fa-edit me-1" />
      Edit
    </button>

    <button
      className="btn btn-sm btn-danger"
      onClick={() => handleDelete(row)}
    >
      <i className="fas fa-trash me-1" />
      Delete
    </button>

  </div>

</td>

              </tr>
            ))}

          </tbody>

        </table>

      </div>

    </div>

    <div
      className="
        card-footer
        d-flex
        justify-content-between
        align-items-center
      "
    >

      <div>

        Total :

        {" "}

        {pagination.total || 0}

      </div>

      <div>

        <button
          className="
            btn
            btn-outline-secondary
            btn-sm
            me-2
          "
          disabled={
            (pagination.page || 1) <= 1
          }
          onClick={() =>
            changePage(
              (pagination.page || 1) - 1
            )
          }
        >
          Previous
        </button>

        <span>

          Page

          {" "}

          {pagination.page || 1}

          {" "}

          of

          {" "}

          {pagination.pages || 1}

        </span>

        <button
          className="
            btn
            btn-outline-secondary
            btn-sm
            ms-2
          "
          disabled={
            (pagination.page || 1) >=
            (pagination.pages || 1)
          }
          onClick={() =>
            changePage(
              (pagination.page || 1) + 1
            )
          }
        >
          Next
        </button>

      </div>

    </div>

  </div>

</div>

);
}
  
